import * as types from '../actiontypes';
import {API_RESOURCES, createApiReadAction} from '../../util/api';

export const getAllDocumentTypes = () => {
	return createApiReadAction(
		types.GET_ALL_DOCUMENT_TYPES,
		{
			[API_RESOURCES.DOCUMENT_TYPES]: null
		}
	);
};
